"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Veneer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const focus_trap_1 = __importDefault(require("focus-trap"));
const body_scroll_lock_1 = require("body-scroll-lock");
const veneer_style_1 = __importDefault(require("./veneer.style"));
const constants_1 = require("../constants");
class Veneer extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.onClickPrimed = false;
        this.deBounce = false;
        this.componentWillUnmount = () => {
            this.deactivateFocusTrap(this.props.returnFocus);
            body_scroll_lock_1.clearAllBodyScrollLocks();
        };
        this.getScrollElement = () => {
            if (!this.props.scrollElementSelector)
                return this.content;
            return document.querySelector(this.props.scrollElementSelector);
        };
        this.componentDidMount = () => {
            body_scroll_lock_1.disableBodyScroll(this.getScrollElement());
            this.trap = focus_trap_1.default(this.content, {
                initialFocus: this.props.focusElement || undefined,
                fallbackFocus: this.content,
                escapeDeactivates: true,
                clickOutsideDeactivates: true,
                returnFocusOnDeactivate: false
            });
            this.trap.activate();
        };
        this.handleCollapse = () => {
            if (this.deBounce)
                return;
            this.deBounce = true;
            window.setTimeout(() => {
                this.deBounce = false;
            }, 100);
            const veneerStack = document.querySelectorAll(`[class="${this.props.classes.root}"]`);
            if (veneerStack[veneerStack.length - 1] === this.veneer) {
                this.deactivateFocusTrap(true);
                this.props.handleCollapse();
            }
        };
        this.handleMouseDown = event => {
            if (this.content.contains(event.target)) {
                this.onClickPrimed = false;
                return;
            }
            this.onClickPrimed = true;
        };
        this.handleMouseUp = event => {
            if (!this.onClickPrimed)
                return;
            this.onClickPrimed = false;
            if (!this.content.contains(event.target)) {
                this.handleCollapse();
            }
        };
        this.handleKeyPress = event => {
            const hotKeys = {
                27: () => {
                    // esc
                    this.handleCollapse();
                }
            };
            if (hotKeys[event.keyCode]) {
                event.preventDefault();
                hotKeys[event.keyCode]();
            }
        };
        this.deactivateFocusTrap = returnFocus => {
            /**
             * returnFocus to element that opened the Veneer
             * true only when deactivated from within this component
             */
            this.trap.deactivate({
                returnFocus
            });
        };
        this.getContentProps = () => {
            const { classes, contentPosition: { top, left, right, bottom } } = this.props;
            const isCentred = !top && !bottom && !left && !right;
            const style = !isCentred && {
                style: {
                    top,
                    left,
                    right,
                    bottom,
                    maxWidth: window.innerWidth -
                        ((left || constants_1.VIEWPORT_MARGIN) + (right || constants_1.VIEWPORT_MARGIN)),
                    maxHeight: window.innerHeight -
                        ((top || constants_1.VIEWPORT_MARGIN) + (bottom || constants_1.VIEWPORT_MARGIN))
                }
            };
            return {
                ref: el => {
                    this.content = el;
                },
                tabIndex: '-1',
                className: classnames_1.default({
                    [classes.content]: true,
                    [classes.contentCentred]: isCentred
                }),
                ...style
            };
        };
        this.render = () => {
            const { classes, children, invisible } = this.props;
            const rootProps = {
                className: classes.root,
                style: {
                    backgroundColor: `rgba(52, 50, 58, ${invisible ? '0' : '0.6'})`
                },
                onMouseDown: this.handleMouseDown,
                onMouseUp: this.handleMouseUp,
                onTouchStart: this.handleMouseDown,
                onTouchEnd: this.handleMouseUp,
                onKeyDown: this.handleKeyPress,
                ref: el => {
                    this.veneer = el;
                }
            };
            return react_dom_1.createPortal(jsx_runtime_1.jsx("div", Object.assign({}, rootProps, { children: jsx_runtime_1.jsx("div", Object.assign({}, this.getContentProps(), { children: children }), void 0) }), void 0), document.body);
        };
    }
}
exports.Veneer = Veneer;
Veneer.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    handleCollapse: prop_types_1.default.func.isRequired,
    invisible: prop_types_1.default.bool,
    focusElement: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.object,
        prop_types_1.default.func
    ]),
    contentPosition: prop_types_1.default.shape({
        top: prop_types_1.default.number,
        left: prop_types_1.default.number,
        right: prop_types_1.default.number,
        bottom: prop_types_1.default.number
    }),
    scrollElementSelector: prop_types_1.default.string,
    returnFocus: prop_types_1.default.bool
};
Veneer.defaultProps = {
    contentPosition: {},
    invisible: false,
    focusElement: null,
    scrollElementSelector: null,
    returnFocus: false
};
exports.default = react_jss_1.default(veneer_style_1.default)(Veneer);
//# sourceMappingURL=veneer.js.map